export { Tag } from './tag'
export type { TagProps } from './tag.types'
